import React, { CSSProperties, FC, useEffect, useState } from 'react';
import { Select } from 'antd';
import { useConnection } from '../../connection/Application';
import { DownOutlined } from '@ant-design/icons';

export type SearchProps = {
  source?: string;
  style?: CSSProperties;
  onChange?: (value?: string | number | Array<string | number>) => void;
  value?: string | number | Array<string | number>;
  mode?: 'multiple' | 'tags' | undefined;
  showSearch?: boolean;
  values?: any[];
  bordered?: boolean;
  disabled?: boolean;
  placeholder?: string;
  onBlur?: (e: any) => void;
  onChangeWithLabel?: (value: any) => void;
};

const SelectSearch: FC<SearchProps> = (props) => {
  const [items, setItems] = useState<{ id: string | number; value: string }[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const { value, onChange, source, showSearch, mode } = props;
  const connection = useConnection();

  useEffect(() => {
    setLoading(true);
    if (!props.values)
      connection
        .get(`common/select/${source}`)
        .then((value1) => setItems(value1.data))
        .finally(() => setLoading(false));
  }, [connection, props.values, source]);

  return (
    <Select
      mode={mode}
      disabled={props.disabled ?? false}
      showSearch={showSearch ?? true}
      bordered={props.bordered ?? true}
      loading={loading}
      placeholder={props.placeholder}
      style={props.style}
      optionFilterProp="children"
      filterOption={(input, option) =>
        option?.props?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      filterSort={(optionA, optionB) =>
        optionA?.props?.children.toLowerCase().localeCompare(optionB?.props.children.toLowerCase())
      }
      suffixIcon={<DownOutlined />}
      onChange={(val) => onChange?.(val as any)}
      value={value}>
      {source &&
        items.map((item) => {
          return (
            <Select.Option key={item.id} value={item.id}>
              {item.value}
            </Select.Option>
          );
        })}
      {props?.values?.map((item) => {
        return (
          <Select.Option key={item.id} value={item.id}>
            {item.value}
          </Select.Option>
        );
      })}
    </Select>
  );
};

export default SelectSearch;
